import React, { useState } from "react";

// Images
import dev1 from "../Assets/nelia.jpeg";
import dev2 from "../Assets/max.jpeg";
import dev3 from "../Assets/dar.jpeg";
import dev4 from "../Assets/gly.png";
import dev5 from "../Assets/lads.png";
import dev6 from "../Assets/jhenica.jpg";
import dev7 from "../Assets/niel.jpeg";
import dev8 from "../Assets/lyzille.jpeg";
import dev9 from "../Assets/glad.jpeg";
import dev10 from "../Assets/joel.jpg";
import land from "../Assets/land.jpeg";
import logo1 from "../Assets/logo1.png";
import lisaLogo from "../Assets/lisa_logo_glass_circle_v2.png";
import logo3 from "../Assets/logo3.png";

const About = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [selectedPhase, setSelectedPhase] = useState(null);

  const [phaseData, setPhaseData] = useState({
    phase1: [
      {
        name: "Nelia Catayas",
        role: "College Dean",
        image: dev1,
        color: "linear-gradient(135deg, #00acc1, #d2cf69)",
      },
      {
  name: "Joel A. Piollo",
  role: "Data Privacy Officer",
  image: dev10,
  color: "linear-gradient(135deg, #de434b, #2575fc)",
},
      {
        name: "Max Angelo D. Perin",
        role: "Backend Consultant & Deployment Engineer",
        image: dev2,
        color: "linear-gradient(135deg, #c2185b, #7b1fa2)",
      },
    ],

    phase2: [
      {
        name: "Nelia Catayas",
        role: "College Dean",
        image: dev1,
        color: "linear-gradient(135deg, #00acc1, #d2cf69)",
      },{
  name: "Joel A. Piollo",
  role: "Data Privacy Officer",
  image: dev10,
  color: "linear-gradient(135deg, #cf4868, #2575fc)",
},
{
      
        name: "Darrel C. Cardana",
        role: "Project Manager",
        image: dev3,
        color: "linear-gradient(135deg, #dede06, #7b1fa2)",
      },
      {
        name: "Max Angelo D. Perin",
        role: "Backend Consultant & Deployment Engineer",
        image: dev2,
        color: "linear-gradient(135deg, #c2185b, #7b1fa2)",
      },
      {
        name: "Glyka Lhen B. Mangmang",
        role: "Project Leader",
        image: dev4,
        color: "linear-gradient(135deg, #cb7bcb, #ef6c00)",
      },
      {
        name: "Lady Marie Dorothy C. Cuadra",
        role: "UI/UX Designer",
        image: dev5,
        color: "linear-gradient(135deg, #43a047, #7f36a4)",
      },
      {
        name: "Jhenica Jane Pagon",
        role: "Frontend Analyst",
        image: dev6,
         color: "linear-gradient(135deg, #1e88e5, #c37b4b)",
      },
    ],
    phase3: [
      {
        name: "Nelia Catayas",
        role: "College Dean",
        image: dev1,
        color: "linear-gradient(135deg, #00acc1, #d2cf69)",
      },{
  name: "Joel A. Piollo",
  role: "Data Privacy Officer",
  image: dev10,
  color: "linear-gradient(135deg, #c05370, #2575fc)",
},
{
        name: "Darrel C. Cardana",
        role: "Project Manager",
        image: dev3,
        color: "linear-gradient(135deg, #dede06, #7b1fa2)",
      },
      {
        name: "Max Angelo D. Perin",
        role: "Backend Consultant & Deployment Engineer",
        image: dev2,
        color: "linear-gradient(135deg, #c2185b, #7b1fa2)",
      },
      {
        name: "Glyka Lhen B. Mangmang",
        role: "Project Leader",
        image: dev4,
        color: "linear-gradient(135deg, #cb7bcb, #ef6c00)",
      },
      {
        name: "Lady Marie Dorothy C. Cuadra",
        role: "UI/UX Designer",
        image: dev5,
        color: "linear-gradient(135deg, #43a047, #7f36a4)",
      },
      {
        name: "Jhenica Jane Pagon",
        role: "Frontend Analyst",
        image: dev6,
        color: "linear-gradient(135deg, #1e88e5, #c37b4b)",
      },
      {
        name: "Niel Adrian B. Garig",
        role: "Backend Analyst",
        image: dev7,
        color: "linear-gradient(135deg, #e2df2e, #1565c0)",
      },
      {
        name: "Lyzille I. Valiao",
        role: "Backend Assistant",
        image: dev8,
        color: "linear-gradient(135deg, #d394e1, #9c3c3c)",
      },
      {
        name: "Gladies S. Catalbas",
        role: "Backend Assistant",
        image: dev9,
        color: "linear-gradient(135deg, #c76249, #62d645)",
      },
    ],
  });

  const updateName = (phase, index, newName) => {
    setPhaseData((prev) => {
      const updated = { ...prev };
      updated[phase] = prev[phase].map((item, i) =>
        i === index ? { ...item, name: newName } : item
      );
      return updated;
    });
  };

  return (
    <div style={styles.container}>
      <div style={styles.overlay}></div>

      <div style={styles.content}>
        {/* LOGOS */}
        <div style={styles.logoContainer}>
        <img src={logo1} alt="Logo 1" style={styles.logoImage} />
        <img src={lisaLogo} alt="LISA Logo" style={styles.logoImage} />
          <img src={logo3} alt="Logo 3" style={styles.logoImage} />
        </div>
        {/* ===== ABOUT SECTION ===== */}
        <section style={styles.description}>
          <h1 style={styles.mainTitle}>L.I.S.A</h1>
          <p style={styles.subtitle}>Local Irrigation Systems Assessment</p>

          <p style={styles.paragraph}>
            L.I.S.A (Local Irrigator System Assessment) is a system designed to
            evaluate, monitor, and analyze the performance and condition of local
            irrigation systems. Its main purpose is to help farmers, irrigation
            managers, and local authorities assess water distribution efficiency,
            infrastructure status, and overall system functionality.
          </p>

          <p style={styles.paragraph}>
            The system collects and processes relevant data such as water flow
            levels, soil moisture conditions, irrigation schedules, and system
            maintenance records. Through structured assessment and analysis, L.I.S.A
            provides insights that support better water management, resource
            allocation, and decision-making.
          </p>

          <p style={styles.paragraph}>
            By identifying inefficiencies, leakages, or maintenance needs, L.I.S.A
            helps improve agricultural productivity, conserve water resources, and
            promote sustainable irrigation practices within local communities.
          </p>
        </section>

        {/* TEAM SECTION */}
        <section style={styles.teamSection}>
          <div style={styles.teamHeader}>
            <h2 style={styles.teamTitle}>Meet Our Team</h2>
            <p style={styles.teamSubtitle}>
              Exceptional and Talented Individuals Driving Innovation
            </p>
          </div>

          <div style={styles.phaseButtonContainer}>
            <button
              style={{
                ...styles.phaseButton,
                ...(selectedPhase === "phase1" ? styles.activeButton : {}),
              }}
              onClick={() => setSelectedPhase("phase1")}
            >
              Phase 1 (2023-2024)
            </button>

            <button
              style={{
                ...styles.phaseButton,
                ...(selectedPhase === "phase2" ? styles.activeButton : {}),
              }}
              onClick={() => setSelectedPhase("phase2")}
            >
              Phase 2 (2024-2025)
            </button>
            <button
  style={{
    ...styles.phaseButton,
    ...(selectedPhase === "phase3"
      ? styles.activeButton
      : {}),
  }}
  onClick={() => setSelectedPhase("phase3")}
>
  Phase 3 (2025-2026)
</button>
          </div>

          {/* Developers Display */}
          {selectedPhase ? (
            <div style={styles.teamGrid}>
              {phaseData[selectedPhase].map((dev, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.card,
                    transform:
                      hoveredCard === index
                        ? "translateY(-10px)"
                        : "translateY(0)",
                  }}
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div
                    style={{
                      ...styles.cardTop,
                      background: dev.color,
                    }}
                  ></div>

                  <img
                    src={dev.image}
                    alt={dev.name}
                    style={styles.profile}
                  />

                  <div style={styles.cardContent}>
                    <input
                      value={dev.name}
                      onChange={(e) =>
                        updateName(selectedPhase, index, e.target.value)
                      }
                      style={styles.nameInput}
                    />
                    <p style={styles.role}>{dev.role}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={styles.placeholder}>
              Please select a phase to view developers
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    padding: "60px 20px",
    backgroundImage: `url(${land})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    position: "relative",
    fontFamily: "Arial, sans-serif",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(255,255,255,0.2)",
  },

  content: {
    position: "relative",
    zIndex: 2,
    maxWidth: "1200px",
    margin: "0 auto",
  },

  description: {
    background: "linear-gradient(135deg, #e0e7ff, #0d7c1c)",
    padding: "60px",
    borderRadius: "12px",
    marginBottom: "100px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  },

  missionVisionSection: {
    marginBottom: "130px",
  },

  mvContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap",
  },

  mvCard: {
  flex: "0 0 500px",           // <-- fixed width you can change
  background: "rgba(208, 220, 197, 0.95)",
  padding: "10px 15px",
  borderRadius: "20px",
  textAlign: "center",
  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
  borderLeft: "10px solid #2e7d32",
  margin: "10px 5px",
},

  mvIconMission: {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    background: "#2e7d32",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    margin: "0 auto 15px auto",
    color: "white",
  },

  mvIconVision: {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    background: "#1565c0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    margin: "0 auto 15px auto",
    color: "white",
  },

  mvTitle: {
    fontSize: "28px",
    fontWeight: "800",
    marginBottom: "15px",
  },

  mvText: {
    fontSize: "18px",
    lineHeight: "1.7",
  },

  logoContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    marginBottom: "40px",
  },

  logoImage: {
    height: "100px",
    objectFit: "contain",
  },

  mainTitle: {
    fontSize: "40px",
    fontWeight: "800",
    marginBottom: "5px",
    color: "#333",
  },

  subtitle: {
    fontSize: "18px",
    fontWeight: "800",
    marginBottom: "20px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "#132fa1",
  },

  paragraph: {
    fontSize: "22px",
    lineHeight: "1.8",
  },

  teamSection: {
    textAlign: "center",
  },

  teamHeader: {
    marginBottom: "40px",
  },

  teamTitle: {
    fontSize: "35px",
    fontWeight: "bold",
  },

  teamSubtitle: {
    fontSize: "25px",
    color: "#a41515",
  },

  phaseButtonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginBottom: "40px",
  },

  phaseButton: {
    padding: "10px 25px",
    borderRadius: "25px",
    border: "2px solid #2e7d32",
    cursor: "pointer",
    fontWeight: "600",
    background: "white",
  },

  activeButton: {
    background: "#2e7d32",
    color: "white",
  },

  teamGrid: {
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    flexWrap: "wrap",
  },

  card: {
    width: "220px",
    background: "white",
    borderRadius: "15px",
    overflow: "hidden",
    boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
    transition: "0.3s ease",
    position: "relative",
  },

  cardTop: {
    height: "100px",
  },

  profile: {
  width: "130px",  // ⬅️ bigger image
  height: "130px",
  borderRadius: "50%",
  objectFit: "cover",
  border: "6px solid white", // thicker border for clarity
  position: "absolute",
  top: "60px", // adjust to center nicely
  left: "50%",
  transform: "translateX(-50%)",
  boxShadow: "0 8px 20px rgba(0,0,0,0.2)", // ⬅️ makes image pop

  },

  cardContent: {
    paddingTop: "95px",
    paddingBottom: "20px",
  },

  nameInput: {
    border: "none",
    outline: "none",
    textAlign: "center",
    fontWeight: "700",
    fontSize: "16px",
    width: "100%",
    background: "transparent",
  },

  role: {
    fontSize: "14px",
    color: "#2e7d32",
    fontWeight: "600",
  },

  placeholder: {
    marginTop: "30px",
    color: "#666",
  },
};

export default About;